import React, { FC } from 'react';
import { Hyperlink } from '../../Hyperlink';
import { SystemButtonHyperlinkProps } from '../button.types';
import { SystemHyperlinkDefault } from '../systemButtonDefaultProps';
import styles from './brand_secondary_button.module.scss';

export const BrandSecondaryHyperlink: FC<SystemButtonHyperlinkProps> = ({
  children,
  target,
  href,
  rel,
  source,
  onClick,
}) => {
  return (
    <Hyperlink
      className={styles.brandSecondary}
      target={target}
      href={href}
      rel={rel}
      source={source}
      onClick={onClick}
    >
      {children}
    </Hyperlink>
  );
};

BrandSecondaryHyperlink.defaultProps = SystemHyperlinkDefault;
